module.exports = __webpack_public_path__ + "img/reference.099370e0.svg";